<template lang="html">
    <div class="page-container">
        <div class="page-container__header">
            <router-link to="/help" tag="div">
                <div class="legal__back">
                    <svg class="pagination__item__icon" wslugth="20" height="20" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-wslugth="2.5" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="15 18 9 12 15 6" />
                    </svg>
                    Înapoi
                </div>
            </router-link>
        </div>
        <div class="page-container__body">
            <div class="legal__card">
                <h1 class="legal__title">{{title}}</h1>
                <div class="legal__content" v-html="content">
                </div>
            </div>
        </div>
    </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { mapActions } from "vuex";

export default {
  data() {
    return {
      slug: this.$route.params.slug,
    };
  },
  computed: {
    ...mapGetters({
      title: "help/termsTitle",
      content: "help/termsContent",
    }),
  },
  methods: {
    ...mapActions({
      termsContent: "help/termsContent",
      clearTermsContent: "help/clearTermsContent",
    }),
  },
  created() {
    this.termsContent(this.slug);
  },
  mounted() {
    //for mobile tables
    setTimeout(function () {
      let tables = document.getElementsByTagName("table");
      if (tables)
        for (var i = 0; i < tables.length; i++) {
          let parent = tables[0].parentNode;
          let wrapper = document.createElement("div");
          wrapper.style.overflow = "auto";

          tables[0].insertAdjacentElement("beforebegin", wrapper);
          wrapper.insertAdjacentElement("afterbegin", tables[0]);
        }
    }, "3000");
  },
  destroyed() {
    this.clearTermsContent();
  },
};
</script>

<style lang="scss" scoped>
.legal {
  &__back {
    align-items: center;
    color: $color-main-text;
    display: flex;
    font-size: 18px;
    font-weight: 500;
    margin: 25px 0;
    text-decoration: none;
    cursor: pointer;

    & > svg {
      margin-right: 10px;
      transition: transform 200ms;
      transform: translateX(-4px);
    }

    &:hover > svg {
      transform: translateX(-6px);
    }
  }

  &__card {
    padding: 30px 0;
    width: 100%;
    display: inline-block;
    background-color: $color-card;
    box-shadow: 0px 0px 20px #0000000f;
  }

  &__title {
    text-align: center;
    font-size: 40px;
    font-weight: 500;
    margin-bottom: 50px;
    // color: $color-primary;

    @include media-breakpoint-down(md) {
      font-size: 32px;
    }
  }

  &__content {
    display: block;
    margin: 25px;
  }
}
</style>
<style scoped>

.legal__content /deep/ *{
    letter-spacing: 0.3px;
}

.legal__content /deep/ strong, b{
  font-weight: 500;
}

.legal__content /deep/ p {
  display: block;
  margin-top: 1em;
  margin-bottom: 1em;
  margin-left: 0;
  margin-right: 0;
  line-height: 1.75;
  font-weight: 300;
}

.legal__content /deep/ h1 {
  font-size: 28px;
  display: block;
  margin-top: 0.67em;
  margin-bottom: 0.67em;
  margin-left: 0;
  margin-right: 0;
}

@media only screen and (min-width: 768px) {
    .legal__content /deep/ h1 {
        font-size: 32px;
    }
}

@media only screen and (min-width: 1200px) {
    .legal__content /deep/ h1 {
        font-size: 40px;
    }
}

.legal__content /deep/ h1 > span{
    color: #373737;
}

.legal__content /deep/ h2 {
  display: block;
  margin-top: 0.83em;
  margin-bottom: 0.83em;
  margin-left: 0;
  margin-right: 0;
}

.legal__content /deep/ h3 {
  display: block;
  margin-top: 1em;
  margin-bottom: 1em;
  margin-left: 0;
  margin-right: 0;
}

.legal__content /deep/ h4 {
  display: block;
  margin-top: 1em;
  margin-bottom: 1em;
  margin-left: 0;
  margin-right: 0;
}

.legal__content /deep/ h5 {
  display: block;
  margin-top: 1.67em;
  margin-bottom: 1.67em;
  margin-left: 0;
  margin-right: 0;
}

.legal__content /deep/ h6 {
  display: block;
  margin-top: 2.33em;
  margin-bottom: 2.33em;
  margin-left: 0;
  margin-right: 0;
}

.legal__content /deep/ ul{
  display: block;
  list-style-type: disc;
  margin-top: 1em;
  margin-bottom: 1 em;
  margin-left: 0;
  margin-right: 0;
  padding-left: 40px;
  line-height: 1.75;
  font-weight: 300;
}

.legal__content /deep/ table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid black;
  object-fit: contain;
}

.legal__content /deep/ th {
  border: 1px solid black;
}

.legal__content /deep/ td {
  padding: 5px;
  border: 1px solid black;
}
</style>